export default __webpack_public_path__ + "media/images/black_arrow-87ae886ce76cae6904983e25f7cc4575.png";